import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
    titleAi: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AdvancedSearchItemCompact.title?c=2bzpzqklevowr", defaultMessage: "Show all results for" }));
                },
                enumerable: true,
                configurable: true
            },
            titleAi: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AdvancedSearchItemCompact.titleAi?c=34xrjttd7whdf", defaultMessage: "AI Search" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
